export const socialNetworks = ['facebook', 'instagram', 'linkdin']